import Vue from 'vue'
import App from './App.vue'
import {store} from './store'
import router from './router'
import vuetify from './plugins/vuetify';
import {currency} from "@/currency";
import axios from 'axios'
import VueAxios from 'vue-axios'

// import VueRx from 'vue-rx'
// // install vue-rx
// Vue.use(VueRx)
import VueRx from "vue-rx";
Vue.use(VueRx);
import VuejsClipper from './plugins/clipper/clipper'
// install vuejs-clipper
Vue.use(VuejsClipper)
Vue.use(VueAxios, axios)

import VuetifyTable from "vuetify-datatable-extended";
import i18n from './i18n'
Vue.use(VuetifyTable);

Vue.config.productionTip = false

Vue.filter('currency', currency)



new Vue({
  store,
  router,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
